import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { getCookie } from "typescript-cookie";
import { useAddOwnershipFormsMutation, useDeleteOwnershipFormsMutation, useEditOwnershipFormsMutation } from "../../../../../redux/api/handBooksApi/ownershipFormsApi";
import { EntDirectoryInfoName } from "../../../../../models/directoryInfoName";



const useOwnershipForms = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation()
    const { confirm } = modal;
    const [addOwnershipForms] = useAddOwnershipFormsMutation();
    const [deleteOwnershipForms] = useDeleteOwnershipFormsMutation();
    const [editOwnershipForms] = useEditOwnershipFormsMutation();


    async function onAddOwnershipForms(newOwnershipForms: EntDirectoryInfoName): Promise<boolean> {
        try {
            let status: boolean = false;
            await addOwnershipForms(newOwnershipForms).then((response: any) => {
                      if (response.error) {
                                 const isKyrgyz = getCookie('i18next') === 'ky';
                                 const lang = isKyrgyz ? 'kg' : 'ru';
                                 const res = response.error.data?.res;
                                 const errorMessages = Array.isArray(res)
                                     ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                     : response.error.data?.msg || t('unknownError'); 
                                 throw new Error(errorMessages);
                             }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if(refresh) refresh();
                }
            }).catch((error:any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });
          
            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }
    async function onDeleteOwnershipForms(ownershipForms: EntDirectoryInfoName) {
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteOwnershipForms(ownershipForms.id as number).then((response: any) => {
                        if (response.error !== undefined && response.error.status === 400) {
                            status = false;
                            throw new Error(response.error.data.message);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({title: t('msg.successDelete')});
                            if(refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });
                        
                    });
                }
            })
            return status
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    async function onEditOwnershipForms(editedOwnershipForms: EntDirectoryInfoName): Promise<boolean> {
        try {
            let status: boolean = false;
            await editOwnershipForms(editedOwnershipForms).then((response: any) => {
                if (response.error !== undefined && response.error.status === 400) {
                    throw new Error(response.error.data.message);
                }
                if (response.data.success) {
                    status = true;
                    Modal.success({title: t('msg.successEdited')});
                    if(refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    return { onAddOwnershipForms ,onDeleteOwnershipForms, onEditOwnershipForms }

}
export { useOwnershipForms};

